import { useEffect, useRef, useState } from "react";
import { Input } from "@/components/ui/input";
import { api } from "@/lib/api";

/** A text box that offers what the register already holds in that column, from the second letter. */
export const SuggestInput = ({
  field,
  value,
  onChange,
  placeholder,
  testId,
  disabled,
  className = "mt-1 h-11 rounded-none",
}) => {
  const [hints, setHints] = useState([]);
  const [open, setOpen] = useState(false);
  const box = useRef(null);
  const typed = value ?? "";

  useEffect(() => {
    const word = String(typed).trim();
    if (word.length < 2 || !open) {
      setHints([]);
      return undefined;
    }
    const t = setTimeout(() => {
      api
        .get("/projects/field-values", { params: { field, q: word } })
        .then((r) => setHints(r.data.values || []))
        .catch(() => setHints([]));
    }, 200);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [typed, field, open]);

  useEffect(() => {
    const away = (e) => {
      if (box.current && !box.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", away);
    return () => document.removeEventListener("mousedown", away);
  }, []);

  const offered = hints.filter((h) => h.toLowerCase() !== String(typed).trim().toLowerCase());

  return (
    <div className="relative" ref={box}>
      <Input
        className={className}
        data-testid={testId}
        placeholder={placeholder}
        value={typed}
        disabled={disabled}
        onFocus={() => setOpen(true)}
        onChange={(e) => {
          setOpen(true);
          onChange(e.target.value);
        }}
        onKeyDown={(e) => {
          if (e.key === "Escape") setOpen(false);
        }}
      />
      {open && offered.length > 0 && (
        <div
          data-testid={`${testId}-suggestions`}
          className="absolute z-50 mt-1 max-h-56 w-full overflow-y-auto border border-border bg-popover shadow-lg"
        >
          {offered.map((h) => (
            <button
              key={h}
              type="button"
              data-testid={`${testId}-suggestion-${h}`}
              onClick={() => {
                onChange(h);
                setOpen(false);
              }}
              className="block w-full truncate px-3 py-2 text-left text-sm transition-colors duration-200 hover:bg-muted"
            >
              {h}
            </button>
          ))}
          <p className="border-t border-border px-3 py-1.5 text-[10px] text-muted-foreground">
            Already in the register — or keep typing something new
          </p>
        </div>
      )}
    </div>
  );
};
